/**
 * @module websocket.event.handlers.flights.flight-list-updated
 */
import { store } from '../../../../state/store'
import { setFlightListUpdated } from '../../../../state/websocket.slice'

export default function handleFlightListUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  if (isSubscribed) {
    store.dispatch(setFlightListUpdated(data))
  }
} 